import React from 'react';
import PropTypes from 'prop-types';
import Logo from '../../components/login/logo';

const Page404 = ({ t }) => (
  <section className="Login boxs">
    <div className="loginleftw">
      <div className="leftinner tc">
        <div className="loginformwidth">
          <div className="loginbox boxs">
            <Logo />
            <p className="fontmulisemi">404</p>
            <p className="fontmulisemi">{t('Page don\'t found or inaccessible')}</p>
          </div>
        </div>
      </div>
    </div>
    <div className="loginrightw">
      <div className="rightinner" />
    </div>
  </section>
);

Page404.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Page404;



// WEBPACK FOOTER //
// ./src/views/page404/Page404.jsx